export default {
  init() {
    // JavaScript to be fired on all pages
    $('.hamburger').click(function(e) {
      e.preventDefault();
      $(this).toggleClass('is-active');
      $("#bs4navbar").toggleClass('show');
    });

    // Prevent show sub-menu on menu link
    $('#bs4navbar a[data-toggle]').click((e) => {
      e.preventDefault();
      const link = $(e.target);
      window.location.href = link.attr('href');
    });

    // Load Cart and User icons in header menu
    //$('#menu-main-menu').append($("#icons-menu-item"));
    //$("#icons-menu-item").removeClass('d-none');
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js